module.exports = __webpack_public_path__ + "img/0Q3A6963_L_Foamcore_MockedUp.ed59c573.jpg";